import React, { useState } from 'react';
import { PageHeading, SectionHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Terms from './components/Terms';
import Submit from '../../components/Submit';

const getBulletItems = (
  isCurrentAccount,
  openBusinessAccount1A,
  altBusinessAccountSubheading1ContentB,
  openBusinessAccount1B,
  dailyLimit,
  openBusinessAccountSmallBusinessText,
  transactionLimit,
  openBusinessAccountMediumBusinessText,
  openBusinessAccountTransactionText
) => {
  const items = [
    isCurrentAccount ? openBusinessAccount1A : altBusinessAccountSubheading1ContentB,
    openBusinessAccount1B
  ];

  if (dailyLimit) {
    items.push(`${openBusinessAccountSmallBusinessText} ${dailyLimit}`);
    transactionLimit && items.push(`${openBusinessAccountMediumBusinessText} ${transactionLimit}`);
  } else if (transactionLimit) {
    items.push(
      `${openBusinessAccountMediumBusinessText} ${transactionLimit} ${openBusinessAccountTransactionText}`
    );
  }

  return items;
};

const OpenBusinessAccountPage = ({
  bankId,
  saveOpenBusinessAccountForm,
  getBusinessData,
  isCurrentAccount,
  isTermsChecked,
  onConfirmationCheckboxChange,
  dailyLimit,
  transactionLimit
}) => {
  const [isFormSubmit, formSubmitted] = useState(false);
  return (
    <Form
      onSubmit={values => {
        formSubmitted(true);
        values.openBusinessAccountTermsAgreement && saveOpenBusinessAccountForm(values);
      }}
      initialValues={getBusinessData}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              openBusinessAccountPageTitle,
              openBusinessChoiceAccountPageTitle,
              openBusinessAccountSubheading1,
              openBusinessAccount1A,
              openBusinessAccount1B,
              openBusinessAccountSubheading2,
              openBusinessAccount2A,
              openBusinessAccount2B,
              openBusinessAccount2C,
              openBusinessAccountSubmit,
              openBusinessAccountHelpText,
              openBusinessAccountSmallBusinessText,
              openBusinessAccountMediumBusinessText,
              openBusinessAccountTransactionText,
              altBusinessAccountSubheading1ContentB,
              openBusinessChoiceAccount
            }) => (
              <div>
                <PageHeading>
                  {isCurrentAccount
                    ? openBusinessAccountPageTitle
                    : openBusinessChoiceAccountPageTitle}
                </PageHeading>
                <SectionHeading>{openBusinessAccountSubheading1}</SectionHeading>
                <BulletList
                  items={getBulletItems(
                    isCurrentAccount,
                    openBusinessAccount1A,
                    altBusinessAccountSubheading1ContentB,
                    openBusinessAccount1B,
                    dailyLimit,
                    openBusinessAccountSmallBusinessText,
                    transactionLimit,
                    openBusinessAccountMediumBusinessText,
                    openBusinessAccountTransactionText
                  )}
                />
                <SectionHeading>{openBusinessAccountSubheading2}</SectionHeading>
                <StandardBody>
                  <p>{openBusinessAccountHelpText}</p>
                </StandardBody>
                <BulletList
                  items={[
                    openBusinessAccount2A,
                    isCurrentAccount ? openBusinessAccount2B : openBusinessChoiceAccount,
                    openBusinessAccount2C
                  ]}
                />

                <Terms
                  isTermsChecked={isTermsChecked}
                  onConfirmationCheckboxChange={onConfirmationCheckboxChange}
                  isFormSubmit={isFormSubmit}
                />

                <Submit submitButtonText={openBusinessAccountSubmit} disabled={!isTermsChecked} />
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
};

OpenBusinessAccountPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveOpenBusinessAccountForm: PropTypes.func.isRequired
};

export default OpenBusinessAccountPage;
